import store from 'owa-mail-store/lib/store/Store';
import { action } from 'satcheljs/lib/legacy';
/**
 * Sets showListPane value in store to passed in value
 * @param showListPane Whether to show list view
 */
export default action('setShowListPane')(function setShowListPane(showListPane) {
    store.mailModule.showListPane = showListPane;
});
//# sourceMappingURL=setShowListPane.js.map